/**
 * Normalise a backend error code to the snake_case our i18n keys use.
 *
 * Codes reach us in whichever casing their source wrote them: snake_case from
 * Commerce (`product_max_quantity_exceeded`), kebab-case from the BFF's own
 * business rules (`item-limit-reached`), and dotted paths from validation
 * field names (`item.quantity`).
 */
export const normalizeErrorCode = (code: string): string =>
  code
    .replace(/([A-Z])/g, (_, char: string) => `_${char.toLowerCase()}`)
    .replace(/[-.]/g, "_");
